export enum LabelPosition {
  Top = "top",
  Left = "left",
}

export enum LabelPlacement {
  Start = "start",
  End = "end",
}

export enum SubmitButtonVariant {
  Primary = "primary",
  Secondary = "secondary",
}

export enum EnhancedButtonPrimeReactSeverity {
  Primary = "", //blue
  Secondary = "secondary", //grey
  Success = "success", // greem
  Info = "info", //blue
  Warning = "warning", //musturd
  Help = "help", //purple
  Danger = "danger", //red
}
